import { useEffect } from 'react';

import { useUnsavedChanges } from 'context/UnsavedChangesContext';

interface UnsavedChangesSyncProps {
  readonly isDirty: boolean;
}

export const UnsavedChangesSync = ({ isDirty }: UnsavedChangesSyncProps) => {
  const { setHasUnsavedChanges } = useUnsavedChanges();

  useEffect(() => {
    setHasUnsavedChanges(isDirty);
  }, [isDirty, setHasUnsavedChanges]);

  useEffect(
    () => () => {
      setHasUnsavedChanges(false);
    },
    [setHasUnsavedChanges]
  );

  return null;
};
